export interface UserFromCache {
  firstName: string;
  lastName: string;
  email: string;
  firstTime?: boolean;
  secret: string;
}

export function isUserFromCache(data?: any): data is UserFromCache {
  if (typeof data !== 'object') return false;
  if (typeof data.firstName !== 'string') return false;
  if (typeof data.lastName !== 'string') return false;
  if (typeof data.email !== 'string') return false;
  return true;
}

export default undefined;
